import React from 'react';

export default function Placeholder({ title = 'Page' }) {
  return (
    <div className="dashboard">
      <div className="card" style={{ padding: '3rem', textAlign: 'center' }}>
        <h2 style={{ margin: '0 0 0.5rem', fontSize: '1.25rem' }}>{title}</h2>
        <p style={{ margin: 0, color: 'var(--text-muted)' }}>Coming soon</p>
      </div>
    </div>
  );
}
